import React, { useEffect } from 'react';

const Visuals = () => {
  useEffect(() => {
    // TikTok-Embed-Script nur einmal laden
    const script = document.createElement('script');
    script.src = 'https://www.tiktok.com/embed.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div id="visuals" className="video-section">
      <h1>Video</h1>

      {/* TikTok */}
      <blockquote
        className="tiktok-embed"
        cite="https://www.tiktok.com/@solidscience/video/7014094279043812613"
        data-video-id="7014094279043812613"
      >
        <section>
          <a href="https://www.tiktok.com/@solidscience/video/7014094279043812613">
            TikTok-Video ansehen
          </a>
        </section>
      </blockquote>

      {/* Facebook */}
      <iframe
        className="video-embed"
        src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2Fimmerwiedersonntags%2Fvideos%2F423318003135920%2F&show_text=0&width=500"
        allowFullScreen={true}
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
      ></iframe>
    </div>
  );
};

export default Visuals;
